<template>
    <v-main>
        <head>
            <title>My Trials - Foraje</title>
            <meta name="description" content="A table of all of your trials">
        </head>
        <v-dialog v-model="trialquickcreatedialog" max-width="750px">
            <newtrial v-on:closenewtrial="trialquickcreatedialog = false" v-on:trialcreated="NewTrialCreated">
            </newtrial>
        </v-dialog>
        <v-container>
            <v-card>
                <v-card-title>
                    <h2>Trials</h2>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="searchvalue"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="trialheaders"
                        :items="trials"
                        class="elevation-1"
                        :loading="aretrialsloading"
                        :search="searchvalue"
                        :pagination.sync="tablepagination"
                        :rows-per-page-items="rowsperpageitems"
                >
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

                    <template slot="no-data">
                        <v-alert :value="!aretrialsloading" color="secondary">
                            Sorry, you have no trials to show here. If you have some we don't know about, Go ahead and create one now!.
                        </v-alert>
                    </template>

                    <template slot="items" slot-scope="props" v-if="!aretrialsloading">
                        <td><router-link :to="'/user/measurements/trials/' + props.item.slug">{{ props.item.name }}</router-link></td>
                        <td>{{ props.item.trial_code }}</td>
                        <td>{{ props.item.measurement_quantity }}</td>
                        <td><v-checkbox
                                v-model="props.item.ongoing"
                                color="primary"
                                hide-details
                                disabled
                        ></v-checkbox>
                        </td>
                        <td class="justify-center layout px-0">
                            <v-icon
                                    small
                                    class="mr-2"
                                    @click="EditThisTrial(props.item)"
                            >
                                edit
                            </v-icon>
                            <v-icon
                                    small
                                    @click="DeleteTrialDialog(props.item)"
                            >
                                delete
                            </v-icon>
                        </td>

                    </template>
                </v-data-table>
            </v-card>

            <v-btn
                    dark
                    fab
                    bottom
                    right
                    fixed
                    color="green"
                    @click="StartQuickCreateTrialDialog"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-container>

    </v-main>
</template>

<script>
import axios from 'axios';
import newtrial from './NewTrial.vue';

export default {
  name: 'MyTrials',
  components: { newtrial },

  data: () => ({
    trials: [],
    errors: [],

    aretrialsloading: false,
    trialquickcreatedialog: false,

    rowsperpageitems: [5, 10, 25, { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }],
    tablepagination: {
      rowsPerPage: 25,
    },

    completetaxonomicinfodisplay: false,
    completetaxonomicinfoloading: false,
    completetaxonomicinfo: [],


    arevarietiesloading: false,
    varietyitems: [],
    selectedvariety: [],
    cropname: '',
    submitloading: false,


    trialeditdialog: false,
    trialtoedit: [],

    editoriginalname: '',

    cropdeletedialog: false,
    cropdeleteloading: false,
    croptodelete: [],


    trialheaders: [
      {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name',
      },
      { text: 'Code', value: 'trial_code', sortable: true },
      { text: 'Measurements', value: 'measurements', sortable: true },
      { text: 'Ongoing', value: 'ongoing', sortable: true },
      { text: 'Edit/Delete', value: 'edit_delete', sortable: false },
    ],
    searchvalue: '',
  }),


  methods: {
    GetThisUsersTrials() {
      this.aretrialsloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('basics/table/measurements/trial/by/submitter/',

        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.trials = response.data;
        })
        .then(() => {
          this.aretrialsloading = false;
        });
    },

    EditThisTrial(item) {
      this.$router.push(`/forms/trials/edit/${item.slug}`);
    },


    EditTrialDialog(item) {
      this.trialeditdialog = true;
      this.trialtoedit = Object.assign({}, item);
      this.editoriginalname = item.name;
    },
    CloseEditTrialDialog() {
      this.trialeditdialog = false;
      this.trialtoedit = [];
      this.editoriginalname = '';
    },


    StartQuickCreateTrialDialog() {
      this.trialquickcreatedialog = true;
    },

    NewTrialCreated() {
      this.GetThisUsersTrials()
        .then(() => {
          this.trialquickcreatedialog = false;
        });
    },

    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },

  },

  // Fetches trials when the component is created.
  created() {
    this.GetThisUsersTrials();
  },


};

</script>

<style scoped>

</style>
